import React from 'react';
import { getAuthProviderLoginUrl } from '../utils/auth_url';

function EstablishPage() {
  const handleLogin = () => {
    const authProviderUrl = getAuthProviderLoginUrl();
    window.location.href = authProviderUrl;
  };

  return (
    <div className="establish-page">
      <div className="establish-content">
        <h1>Liminal</h1>
        <h2>Coaching Agent</h2>
        <button className="get-started-button" onClick={handleLogin}>
          Get Started
        </button>
      </div>
    </div>
  );
}

export default EstablishPage; 